var AxisState = /** @class */ (function () {
    function AxisState(axisType, yExtent, positionInGroup) {
        this.axisType = axisType;
        this.yExtent = yExtent;
        this.positionInGroup = positionInGroup;
    }
    return AxisState;
}());
export { AxisState };
